webpackJsonp([7,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var Shared = __webpack_require__(39);
	var Carousel = __webpack_require__(222);
	var LanguageManager = __webpack_require__(38);
	var Utils = __webpack_require__(25);
	
	__webpack_require__(914);
	
	$(function () {
	  Shared.init();
	  FigurinesPage.init();
	});
	
	var FigurinesPage = {};
	
	(function (FigurinesPage) {
	  var element = $(".carousel-wrapper");
	  var carousel;
	
	  var startAt = "karla";
	  if (window.location.hash !== "") startAt = window.location.hash;
	
	  FigurinesPage.init = function () {
	    carousel = new Carousel({
	      element: element,
	      centered: true,
	      clickCallBack: onCarouselClicked,
	      startAt: startAt
	    });
	
	    element.on("afterChange", function (event, slick, currentSlide) {
	      var el = $(slick.$slides[currentSlide]).find(".figurine-slide");
	      var id = el.data("figurine-id");
	      var sex = el.data("figurine-sex");
	
	      $(".figurines-portrait-figurine").hide();
	      $(".figurines-portrait-figurine." + id).show();
	
	      $("#figurines-passport-name").text(LanguageManager.getValueForKey("figurines." + id + ".name"));
	      $("#figurines-passport-description").html(LanguageManager.getValueForKey("figurines." + id + ".description"));
	      $("#figurines-passport-animal").text(LanguageManager.getValueForKey("figurines." + id + ".animal"));
	      $("#figurines-passport-female").text(LanguageManager.getValueForKey("figurines." + id + ".female"));
	      $("#figurines-passport-male").text(LanguageManager.getValueForKey("figurines." + id + ".male"));
	      $("#figurines-passport-age").text(LanguageManager.getValueForKey("figurines." + id + ".age"));
	      $("#figurines-passport-hobby").text(LanguageManager.getValueForKey("figurines.hobby.label") + LanguageManager.getValueForKey("figurines." + id + ".hobby"));
	      $("#figurines-passport-relation").text(LanguageManager.getValueForKey("figurines.relation.label") + LanguageManager.getValueForKey("figurines." + id + ".relation"));
	      $("#figurines-passport-food").text(LanguageManager.getValueForKey("figurines.food.label") + LanguageManager.getValueForKey("figurines." + id + ".food"));
	
	      if (sex === "male") {
	        $("#figurines-passport-female-symbol").removeClass("inactive").addClass("inactive");
	        $("#figurines-passport-male-symbol").removeClass("inactive");
	        $("#figurines-passport-female").removeClass("inactive").addClass("inactive");
	        $("#figurines-passport-male").removeClass("inactive");
	      } else {
	        $("#figurines-passport-female-symbol").removeClass("inactive");
	        $("#figurines-passport-male-symbol").removeClass("inactive").addClass("inactive");
	        $("#figurines-passport-female").removeClass("inactive");
	        $("#figurines-passport-male").removeClass("inactive").addClass("inactive");
	      }
	
	      window.location.hash = id;
	    });
	
	    Utils.ImageSVGToSVG();
	  };
	
	  function onCarouselClicked(e) {
	    var el = $(e.currentTarget).find(".figurine-slide");
	
	    window.location.hash = el.data("figurine-id");
	  }
	})(FigurinesPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./fr-BE.json": 42,
		"./nl-BE.json": 43
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 37;


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./figurine_astrid.png": 344,
		"./figurine_bea.png": 345,
		"./figurine_caroline.png": 346,
		"./figurine_corinne.png": 347,
		"./figurine_cornelus.png": 348,
		"./figurine_didier.png": 349,
		"./figurine_diego.png": 350,
		"./figurine_gerry.png": 351,
		"./figurine_henry.png": 352,
		"./figurine_herbert.png": 353,
		"./figurine_karla.png": 354,
		"./figurine_kitou.png": 355,
		"./figurine_leon.png": 356,
		"./figurine_martin.png": 357,
		"./figurine_maurice.png": 358,
		"./figurine_max.png": 359,
		"./figurine_milla.png": 360,
		"./figurine_olga.png": 361,
		"./figurine_pol.png": 362,
		"./figurine_renee.png": 363,
		"./figurine_ric.png": 364,
		"./figurine_sam.png": 365,
		"./figurine_viktor.png": 366,
		"./figurine_waldo.png": 367
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 221;


/***/ }),

/***/ 914:
907

});


// WEBPACK FOOTER //
// js/figurines.847b0d2c114d773cea3e.js